import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import AdminHeader from './header/AdminHeader';
import PageFooter from './footer/PageFooter';
import Drawer from '../components/tool/Drawer';
import SideMenu from '../components/menu/SideMenu';
import Setting from '../components/setting/Setting';
import { updatepwd } from '../services/user';
import { mapState, mapMutations, mapGetters } from 'vuex';

// const minHeight = window.innerHeight - 64 - 122
import AccountFormModel from "@/pages/systemsettings/account/accountFormModel.vue";
import { updateAdminPwd } from "@/services/accountList";
// import {pwdList} from "@/pages/systemsettings/account/config";
import basucSettingsMessages from "@/pages/systemsettings/i18n-basucSettings";
export default {
  name: 'AdminLayout',
  components: {
    Setting: Setting,
    SideMenu: SideMenu,
    Drawer: Drawer,
    PageFooter: PageFooter,
    AdminHeader: AdminHeader,
    AccountFormModel: AccountFormModel
  },
  data: function data() {
    var _this = this;
    var messages = basucSettingsMessages.messages;
    Object.keys(messages).forEach(function (lang) {
      _this.$i18n.mergeLocaleMessage(lang, messages[lang]);
    });
    var checkPwd = function checkPwd(rule, value, callback) {
      if (value == '') {
        callback(new Error(_this.$t('account.pwdRule4')));
      } else if (value !== _this.form.pwd) {
        callback(new Error(_this.$t('account.pwdRule2')));
      } else {
        callback();
      }
    };
    var checkNewPwd = function checkNewPwd(rule, value, callback) {
      if (value == '') {
        callback(new Error(_this.$t('account.pwdRule1')));
      } else if (value !== _this.form.newPwd) {
        callback(new Error(_this.$t('account.pwdRule2')));
      } else {
        callback();
      }
    };
    var addRules = {
      account: [{
        required: true,
        message: this.$t('account.emailRule2'),
        trigger: 'blur'
      }, {
        message: this.$t('account.userLength'),
        min: 2,
        max: 60,
        trigger: 'blur'
      }],
      name: [{
        required: true,
        message: this.$t('account.nameRule'),
        trigger: 'blur'
      }, {
        min: 2,
        max: 18,
        message: this.$t('account.nameLength'),
        trigger: 'blur'
      }],
      pwd: [{
        required: true,
        message: this.$t('account.pwdRule4'),
        trigger: 'blur'
      }, {
        min: 4,
        max: 20,
        message: this.$t('account.pwdLength'),
        trigger: 'blur'
      }],
      newPwd: [{
        required: true,
        message: this.$t('account.pwdRule3'),
        trigger: 'blur'
      }, {
        min: 4,
        max: 20,
        message: this.$t('account.pwdLength')
      }],
      confirmPwd: [{
        required: true,
        message: this.$t('account.confirmPwdPlace'),
        trigger: 'blur'
      }, {
        required: true,
        validator: checkPwd,
        trigger: ['change', 'blur']
      }],
      confirmNewPwd: [{
        required: true,
        message: this.$t('account.confirmPwdPlace'),
        trigger: 'blur'
      }, {
        required: true,
        validator: checkNewPwd,
        trigger: ['change', 'blur']
      }],
      isAdmin: [{
        required: true,
        trigger: 'change'
      }]
    };
    var pwdList = [{
      type: 'inputPwd',
      name: this.$t('account.newPwd'),
      disabled: false,
      prop: 'newPwd',
      length: 20
    }, {
      type: 'inputPwd',
      name: this.$t('account.confirmPwd'),
      disabled: false,
      prop: 'confirmNewPwd',
      length: 20
    }];
    return {
      minHeight: window.innerHeight - 64 - 122,
      collapsed: false,
      showSetting: false,
      drawerOpen: false,
      visible: false,
      userInfo: {
        oldPasswd: "",
        newPasswd: ""
      },
      title: '',
      rules: {},
      // 添加/编辑/修改密码 表单 rules
      form: {},
      // 添加/编辑/修改密码 表单form
      formList: [],
      // 添加/编辑/修改密码 弹窗 使用的字段列表
      addRules: addRules,
      // 添加/编辑/修改密码 弹窗标题
      pwdList: pwdList // 修改密码form 字段列表
    };
  },
  provide: function provide() {
    return {
      adminLayout: this
    };
  },
  watch: {
    $route: function $route(val) {
      this.setActivated(val);
    },
    layout: function layout() {
      this.setActivated(this.$route);
    },
    isMobile: function isMobile(val) {
      if (!val) {
        this.drawerOpen = false;
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('setting', ['isMobile', 'theme', 'layout', 'footerLinks', 'copyright', 'fixedHeader', 'fixedSideBar', 'fixedTabs', 'hideSetting', 'multiPage'])), mapGetters('setting', ['firstMenu', 'subMenu', 'menuData'])), {}, {
    sideMenuWidth: function sideMenuWidth() {
      return this.collapsed ? '80px' : '220px';
    },
    headerStyle: function headerStyle() {
      var width = this.fixedHeader && this.layout !== 'head' && !this.isMobile ? "calc(100% - ".concat(this.sideMenuWidth, ")") : '100%';
      var position = this.fixedHeader ? 'fixed' : 'static';
      return "width: ".concat(width, "; position: ").concat(position, ";");
    },
    headMenuData: function headMenuData() {
      var layout = this.layout,
        menuData = this.menuData,
        firstMenu = this.firstMenu;
      return layout === 'mix' ? firstMenu : menuData;
    },
    sideMenuData: function sideMenuData() {
      var layout = this.layout,
        menuData = this.menuData,
        subMenu = this.subMenu;
      return layout === 'mix' ? subMenu : menuData;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('setting', ['correctPageMinHeight', 'setActivatedFirst'])), {}, {
    handleOk: function handleOk() {
      var _this2 = this;
      this.$refs["userInfo"].validate(function (valid) {
        if (valid) {
          if (_this2.userInfo.oldPasswd == _this2.userInfo.newPasswd) {
            _this2.$message.warn("新密码不能与旧密码相同");
            return;
          }
          updatepwd({
            oldPwd: _this2.userInfo.oldPasswd,
            newPwd: _this2.userInfo.newPasswd
          }).then(function (res) {
            var _res$data = res.data,
              status = _res$data.status,
              message = _res$data.message;
            if (status) {
              _this2.$message.success("修改成功");
              _this2.visible = false;
            } else {
              _this2.$message.error(message);
            }
          });
        }
      });
    },
    handleCancel: function handleCancel(e) {
      this.visible = false;
    },
    editPwd: function editPwd() {
      var pwdForm = {
        newPwd: '',
        confirmNewPwd: ''
      };
      this.rules = this.addRules;
      this.form = pwdForm;
      this.title = this.$t('account.changePwd');
      this.formList = this.pwdList;
      this.visible = true;
    },
    toggleCollapse: function toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    onMenuSelect: function onMenuSelect() {
      this.toggleCollapse();
    },
    setActivated: function setActivated(route) {
      var _this3 = this;
      if (this.layout === 'mix') {
        var matched = route.matched;
        matched = matched.slice(0, matched.length - 1);
        var firstMenu = this.firstMenu;
        var _iterator = _createForOfIteratorHelper(firstMenu),
          _step;
        try {
          var _loop = function _loop() {
            var menu = _step.value;
            if (matched.findIndex(function (item) {
              return item.path === menu.fullPath;
            }) !== -1) {
              _this3.setActivatedFirst(menu.fullPath);
              return 1; // break
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            if (_loop()) break;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    /**
    * 添加/编辑/修改 ok
    * @param form 表单ref
    */
    ok: function ok(form) {
      var _this4 = this;
      console.log('form', this.form);
      form.validate(function (valid) {
        if (valid) {
          var promise = _this4.handleChangePassword();
          promise.then(function () {
            _this4.visible = false;
            _this4.form = {};
            form.resetFields();
          });
        }
      });
    },
    /**
    * 处理修改密码
    */
    handleChangePassword: function handleChangePassword() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var id, params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              id = -1;
              params = {
                id: id,
                password: _this5.form.newPwd,
                enpassword: _this5.form.confirmNewPwd
              };
              _context.n = 1;
              return updateAdminPwd(id, params);
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this5.$message.success(_this5.$t('public.changeSuccessfully'));
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 添加/编辑/修改 取消
     * @param form
     */
    cancel2: function cancel2(form) {
      this.form = {};
      this.visible = false;
      form.resetFields();
    }
  }),
  created: function created() {
    this.correctPageMinHeight(this.minHeight - 24);
    this.setActivated(this.$route);
  },
  beforeDestroy: function beforeDestroy() {
    this.correctPageMinHeight(-this.minHeight + 24);
  }
};